import React, { useEffect } from "react";
// import AboutOne from "../components/AboutOne";
// import BrandTwo from "../components/BrandTwo";
import Breadcrumb from "../components/Breadcrumb";
// import CertificateOne from "../components/CertificateOne";
// import ChooseUsOne from "../components/ChooseUsOne";
// import CounterOne from "../components/CounterOne";
// import FooterOne from "../components/FooterOne";
import HeaderOne from "../components/HeaderOne";
// import InstructorOne from "../components/InstructorOne";
// import TestimonialsOne from "../components/TestimonialsOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import FooterThree from "../components/FooterThree";
import { useLoader } from "../context/LoaderContext";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import { FetchAllApi } from "../components/FetchAllApi";
import { useAllDataContext } from "../context/AllDataContext";
import { useLocation } from "react-router-dom";
import BlogListInner from "../components/BlogListInner";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const FacilitiesPage = () => {
  const { companyDetailsData, setCompanyDetailsData } =
      useCompanyDetailsContext();
  const { setLoading } = useLoader();
  // const [facilitiesData, setFacilitiesData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);

  const { allData, setAllData } = useAllDataContext();
  const facilitiesData = allData.facilitiesData;
  const facilitiesBannerData = allData.allBannerData[0]?.facilities_title;
  FetchAllApi({ companyDetailsData, setAllData, setLoading });

  // useEffect(() => {
  //   setLoading(true);
  //   Promise.all([fetchFacilitiesList()])
  //     .then(([facilitiesList]) => {
  //       setFacilitiesData(facilitiesList);
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     })
  //     .catch(() => {
  //       console.error("Server Error");
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     });
  // }, [setLoading]);
  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        heading={facilitiesBannerData}
        title={"Student Life"}
        subTitle={"Facilities"}
      />

      {/* AboutOne */}
      {/* <AboutOne /> */}

      {/* InstructorOne */}
      {/* <InstructorOne /> */}

      {/* ChooseUsOne */}
      {/* <ChooseUsOne /> */}

      {/* CounterOne */}
      {/* <CounterOne /> */}

      {/* TestimonialsOne */}
      {/* <TestimonialsOne facilitiesData={facilitiesData} /> */}
      <BlogListInner studentLifeData={facilitiesData} />

      {/* BrandTwo */}
      {/* <BrandTwo /> */}

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default FacilitiesPage;
